<template>
  <VContainer class="pa-0">
    <VCardText class="py-0 text-primary" style="position:relative;">
      <DemonstratorContactInfo
        :demonstrator="demonstrator"
        :avatar-size="avatarSize"
        :can-clear="canClear"
        :show-personal-contact="showPersonalContact"
        @change-demo="emits('change-demo')"
      />
    </VCardText>

    <!-- Connect with Me -->
    <VCardActions v-if="showMedia" class="pt-0">
      <DemonstratorSocialMedia
        :demonstrator="demonstrator"
        :media-open="mediaOpen"
      />
    </VCardActions>
    <slot />
  </VContainer>
</template>

<script setup lang="ts">
import type { Demonstrator } from '~/types/account'
import DemonstratorContactInfo from '~/components/account/demonstrator/DemonstratorContactInfo.vue'
import DemonstratorSocialMedia from '~/components/account/demonstrator/DemonstratorSocialMedia.vue'

interface Props {
  demonstrator: Demonstrator
  canClear?: boolean
  showPersonalContact?: boolean
  showMedia?: boolean
  mediaOpen?: boolean
  avatarSize?: number
}

withDefaults(defineProps<Props>(), {
  canClear: true,
  showPersonalContact: false,
  showMedia: true,
  mediaOpen: false,
  avatarSize: 165
})

const emits = defineEmits<{
  (e: 'change-demo'): void
}>()
</script>
